import { render } from "./ChartSales.vue?vue&type=template&id=caf40916&scoped=true"
import script from "./ChartSales.vue?vue&type=script&lang=js"
export * from "./ChartSales.vue?vue&type=script&lang=js"

import "./ChartSales.vue?vue&type=style&index=0&id=caf40916&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf40916"]])

export default __exports__